import { createSlice } from '@reduxjs/toolkit';

export const categorySlice = createSlice({
    name: 'category',
    initialState: null,
    reducers: {
        categorySet: (state, action) => {
            return action.payload;
        }
    }
});

export const { categorySet } = categorySlice.actions;
export default categorySlice.reducer;
